import { render } from "./index.vue?vue&type=template&id=654b64d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=654b64d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-654b64d8"

export default script